"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var gatsby_1 = require("gatsby");
var base_1 = __importDefault(require("../styles/base"));
var react_helmet_1 = require("react-helmet");
var NameBarFixed_1 = __importDefault(require("../components/NameBarFixed"));
var nav_1 = __importDefault(require("../components/nav"));
var react_1 = __importDefault(require("react"));
var react_2 = require("@emotion/react");
var IndexLayout = function IndexLayout(_ref) {
    var children = _ref.children;
    return react_2.jsx(gatsby_1.StaticQuery, {
        query: "1963140206",
        render: function render(data) {
            return react_2.jsx(react_1.default.Fragment, null, react_2.jsx(react_helmet_1.Helmet, null, react_2.jsx("meta", {
                lang: "eng"
            }), react_2.jsx("meta", {
                charSet: "utf-8"
            }), react_2.jsx("title", null, data.site.siteMetadata.title), react_2.jsx("meta", {
                name: "description",
                content: data.site.siteMetadata.description
            })), react_2.jsx(base_1.default, null), react_2.jsx(NameBarFixed_1.default, null), react_2.jsx(nav_1.default, null), react_2.jsx("main", null, children), react_2.jsx("div", {
                dangerouslySetInnerHTML: {
                    __html: "<!-- Google tag (gtag.js) -->\n        <script async src=\"https://www.googletagmanager.com/gtag/js?id=G-SJ1Q2LXFPM\"></script>\n        <script>\n          window.dataLayer = window.dataLayer || [];\n          function gtag(){dataLayer.push(arguments);}\n          gtag('js', new Date());\n\n          gtag('config', 'G-SJ1Q2LXFPM');\n        </script>"
                }
            }));
        }
    });
};
exports.default = IndexLayout;
